// ABOUTME: Maps legacy Settings feature names to shared feature-flag keys.
// ABOUTME: Keeps the complete legacy Feature contract available during endpoint migration.
import {Feature} from '@hconnect/common/enums'
import {FeatureFlagKey} from '@hproduce/feature-flags'

export const settingsFeatureFlagKeys = {
  [Feature.Stock]: FeatureFlagKey.Stock,
  [Feature.PriceForecast]: FeatureFlagKey.PriceForecast,
  [Feature.DemandForecast]: FeatureFlagKey.DemandForecast,
  [Feature.Planning]: FeatureFlagKey.Planning,
  [Feature.ElectricityPurchasing]: FeatureFlagKey.LegacyElectricityPurchasing,
  [Feature.ControlOperatorScreen]: FeatureFlagKey.ControlOperatorScreen,
  [Feature.PlanningComments]: FeatureFlagKey.LegacyPlanningComments,
  [Feature.OperatorViewExactElectricityPrices]:
    FeatureFlagKey.LegacyOperatorViewExactElectricityPrices,
  [Feature.OperatorViewColorCodedElectricityPrices]:
    FeatureFlagKey.LegacyOperatorViewColorCodedElectricityPrices,
  [Feature.ShutdownAvailability]: FeatureFlagKey.LegacyShutdownAvailability,
  [Feature.CostAvoidance]: FeatureFlagKey.LegacyCostAvoidance,
  [Feature.UpmAssetsAndStorages]: FeatureFlagKey.UpmAssetsAndStorages,
  [Feature.NewStandardOperationTimes]: FeatureFlagKey.NewStandardOperationTimes,
  [Feature.JanusShowPssTab]: FeatureFlagKey.JanusShowPssTab,
  [Feature.EnableOptimizedAssets]: FeatureFlagKey.EnableOptimizedAssets
} satisfies Record<Feature, FeatureFlagKey>
